import { Injectable, OnDestroy } from '@angular/core';
import { ARLTableCalculationPosition } from './arl-table-position-helper';
import { Store } from '@ngrx/store';
import { State } from '../../../../dave-data-module/State';
import { CalculationArlFormDataService } from '../calculation-arl-form-data.service';
import { MaterialDataService } from '../../../../dave-data-module/services/material-data.service';
import { ArlFormDataService } from '../arl-form-data.service';
import { ArlDataService } from '../../../../dave-data-module/services/arl-data.service';
import { Observable } from 'rxjs';
import { LedgerImportARLCalculationPreChargeByType } from '../../../../dave-data-module/entities/ledger-import.entity';
import { number } from 'mathjs';
import {
    AccountsReceivableLedgerTypeEnum
} from '../../../../dave-data-module/entities/accounts-receivable-ledger.entity';

@Injectable()
export class ArlTablePositionHelperService implements OnDestroy {

    private arlCalculationHelper: Map<number, ARLTableCalculationPosition> = new Map<number, ARLTableCalculationPosition>();

    constructor(private store: Store<State>,
                private calcArlFormDataService: CalculationArlFormDataService,
                private materialDataService: MaterialDataService,
                private arlFormDataService: ArlFormDataService,
                private arlDataService: ArlDataService,
    ) {
        console.log('ArlTablePositionHelperService initialized');
    }

    setArlCalculationHelper(
        arlValues: {
            arlId: number,
            ledgerImportId: number,
            multiplier: number
        },
        positionPrefix$: Observable<string>,
        aRLCalculationPreChargeByTypes$: Observable<LedgerImportARLCalculationPreChargeByType[]>,
        aRLCalculationPreCharge$: Observable<number>,
        arlSurchargeByTypes$: Observable<{
            percentage: number
            arlType: AccountsReceivableLedgerTypeEnum
        }[]>,
        onAmountCalculated: (amount: { BaseCost: number; SalaryBaseCost: number }) => void,
        ): void {
        this.arlCalculationHelper.set(arlValues.arlId, new ARLTableCalculationPosition(
            this.store,
            this.arlFormDataService,
            this.calcArlFormDataService,
            this.arlDataService,
            this.materialDataService,
            arlValues.arlId,
            arlValues.ledgerImportId,
            arlValues.multiplier,
            onAmountCalculated,
            positionPrefix$,
            aRLCalculationPreChargeByTypes$,
            aRLCalculationPreCharge$,
            arlSurchargeByTypes$,
        ));
    }

    getArlCalculationHelper(arlId: number): ARLTableCalculationPosition {
        return this.arlCalculationHelper.get(arlId);
    }

    ngOnDestroy(): void {
        this.arlCalculationHelper.forEach((arlCalculationPosition) => {
            arlCalculationPosition.destroy();
        });
    }

}
